import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { authenticatedApiCall } from '../../utils/apiClient';

// Permission check component
const AccessDenied = () => (
  <div style={{
    padding: '2rem',
    textAlign: 'center',
    backgroundColor: '#f8d7da',
    border: '1px solid #f5c6cb',
    borderRadius: '8px',
    color: '#721c24'
  }}>
    <h3 style={{ margin: '0 0 0.5rem 0' }}>🔒 Access Denied</h3>
    <p style={{ margin: 0 }}>HSE Report is available to Project Managers (and above) and Safety department users.</p>
  </div>
);

const HSEReport = () => {
  const { instance, accounts } = useMsal();
  
  // Permission states
  const [hasPermission, setHasPermission] = useState(null);
  const [permissionLoading, setPermissionLoading] = useState(true);

  // Check permissions on mount
  useEffect(() => {
    const checkPermissions = async () => {
      try {
        const response = await authenticatedApiCall(instance, accounts, 'GET', '/auth/permissions-info');
        if (response.data.success) {
          const data = response.data.data || {};
          const isAdmin = data.isAdmin || data.isSuperadmin || false;
          const auth = data.authorityLevel;
          const depts = data.allDepartmentIds || [];
          const pmOrAbove = ['System', 'Upper Management', 'Manager'].includes(auth);
          const isSafety = depts.some((id) => Number(id) === 5);
          setHasPermission(isAdmin || pmOrAbove || isSafety);
        } else {
          setHasPermission(false);
        }
      } catch (error) {
        console.error('Error checking permissions:', error);
        setHasPermission(false);
      } finally {
        setPermissionLoading(false);
      }
    };
    checkPermissions();
  }, [instance, accounts]);

  // Permission check - show loading or access denied
  if (permissionLoading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p style={{ color: '#6b7280' }}>Checking permissions...</p>
      </div>
    );
  }

  if (!hasPermission) {
    return <AccessDenied />;
  }

  return (
    <div>
      {/* Header */}
      <div style={{
        marginBottom: '1rem',
        padding: '1rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
        border: '1px solid #dee2e6'
      }}>
        <h2 style={{ margin: '0 0 0.5rem 0', fontSize: '1.5rem', color: '#333' }}>
          LGL Safety Consolidated Report
        </h2>
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
          This report displays live HSE (Health, Safety, and Environment) data from your Power BI workspace. 
          The data refreshes automatically as you interact with the report.
        </p>
      </div>

      {/* Power BI Iframe */}
      <div style={{
        border: '1px solid #dee2e6',
        borderRadius: '4px',
        overflow: 'hidden',
        backgroundColor: '#fff'
      }}>
        <iframe 
          title="LGL Safety Consolidated Report" 
          width="100%" 
          height="600" 
          src="https://app.powerbi.com/view?r=eyJrIjoiNmJjY2E0ZDgtYmFmZC00Y2IwLThhMWQtMjUzNmViMWE3ZTM1IiwidCI6IjNjZGJhM2RmLWYzZTgtNDQ3OC04NzM2LWVlMmQ2MzAwNzI0NiJ9" 
          frameBorder="0" 
          allowFullScreen={true}
          style={{
            display: 'block',
            border: 'none'
          }}
        />
      </div>

      {/* Info Footer */}
      <div style={{
        marginTop: '1rem',
        padding: '0.75rem',
        backgroundColor: '#e7f3ff',
        border: '1px solid #b3d9ff',
        borderRadius: '4px',
        fontSize: '0.85rem',
        color: '#004085'
      }}>
        <strong>ℹ️ Note:</strong> This report uses DirectQuery and displays live data from your database. 
        Changes in the database are reflected immediately when you interact with filters or refresh your browser.
      </div>
    </div>
  );
};

export default HSEReport;





